const Tooltip = {
  baseStyle: {
    bg: 'brand.grey',
  },
}

export default Tooltip
